import pizzeria_search_input from "./components/pizzeria-search-input";
import pizzeria_search_select from "./components/pizzeria-search-selects";
import $ from "jquery";
import new_map from "./components/map";

// function initMaps() {
//   pizzeria_search_input();
//   pizzeria_search_select();
// }

// window.initMaps = initMaps;

function myTest() {
  pizzeria_search_input();
  pizzeria_search_select();

  $(document).ready(function() {
    $(".acf-map").each(function() {
      // create map
      new_map($(this));
    });
  });

  console.log("test");
}

window.myTest = myTest;
